<template>
    <div v-if="widget.attributes.imgS3Key != undefined" class="col-md-12 text-center">
        <button class="button action btn-widget-synoptic" v-html="widget.attributes.title.attributeValue"></button>
        <div class="widget-07">
            <expandable-image :close-on-background-click="true" :src="widget.attributes.imgS3Key.attributeValue" :alt="widget.attributes.title != undefined ? widget.attributes.title.attributeValue: ''" />
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import VueExpandableImage from 'vue-expandable-image'

    Vue.use(VueExpandableImage)

    export default {
        props: ['widget'],
    }
</script>